import { IAddWordingsState } from './addWordingsContext';
import { AddWordingsActionsTypes, TAddWordingsAction } from './addWordingsActions';

export const addWordingsReducer = (state: IAddWordingsState, action: TAddWordingsAction): IAddWordingsState => {
	switch (action.type) {
		case AddWordingsActionsTypes.SET_ID_CATEGORY:
			return {
				...state,
				IDSelectedCategory: action.payload.IDSelectedCategory,
			};
		case AddWordingsActionsTypes.CHANGE_KEY:
			return {
				...state,
				key: action.payload.key,
			};
		case AddWordingsActionsTypes.SET_FETCHED_LANGUAGES:
			return {
				...state,
				fetchedLanguages: action.payload.fetchedLanguages,
			};
		case AddWordingsActionsTypes.CHANGE_TRANSLATIONS:
			return {
				...state,
				translations: action.payload.translations,
			};
		case AddWordingsActionsTypes.SET_DATA_FOR_SUBMIT:
			return {
				...state,
				dataForSubmit: action.payload.dataForSubmit,
			};
		case AddWordingsActionsTypes.RESET_FIELDS:
			return {
				...state,
				IDSelectedCategory: null,
				key: '',
				translations: state.translations.map((el) => ({ ...el, value: '', label: '' })),
				typeOfModalWindow: null,
			};
		case AddWordingsActionsTypes.CHANGE_TYPE_OF_MODAL_WINDOW:
			return {
				...state,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		default:
			return state;
	}
};
